import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ICompanyJobTitle } from '../../../../message-models/company-job-title.interface';
import { IJobTitleInfo } from '../../../../message-models/job-title.interface';
import { IJobLevelInfo } from '../../../../message-models/job-level.interface';
import { IOperativeTypeInfo } from '../../../../message-models/operative-type.interface';
import { IOperative } from '../../../../message-models/operative.interface';
import { CompanyJobRoleService } from '../../services/company-job-role.service';
import { CompanyJobTitle } from '../../../../message-models/company-job-title.class';

@Component({
  selector: 'app-company-job-role-modal',
  templateUrl: './company-job-role-modal.component.html',
  styleUrls: ['./company-job-role-modal.component.scss']
})
export class CompanyJobRoleModalComponent implements OnInit {


  @Input() heading: string = "Company Job Role Editor";
  @Input() editing: boolean = false;
  @Input() companyJobTitle: CompanyJobTitle = new CompanyJobTitle();
 
  saveAttempted: boolean = false;

  @Output() saveCompanyJobTitleClicked: EventEmitter<ICompanyJobTitle> = new EventEmitter<ICompanyJobTitle>();
  @Output() cancelCompanyJobTitleClicked: EventEmitter<any> = new EventEmitter<any>();
  showingHelp: boolean = false;
  @Output() refreshCompanyJobTitleSuggested: EventEmitter<boolean> = new EventEmitter<boolean>();
  temp: ICompanyJobTitle;
  companyJobTitles: ICompanyJobTitle[] = [];
  constructor(public config: DynamicDialogConfig,
        private companyJobRoleService: CompanyJobRoleService,

  ) { }


  ngOnInit(): void {

    if (this.config.data) {
      this.heading = this.config.data.heading; 
      this.editing = this.config.data.editing;
      this.companyJobTitle = this.config.data.companyJobTitle;
      this.temp = this.config.data.companyJobTitle;
       
    };

  }


  cancelClicked() {
    this.editing = false;
 
    this.cancelCompanyJobTitleClicked.emit();
    this.refreshCompanyJobTitleSuggested.emit(true);
  }

  saveCompanyJobTitle() {
    this.saveAttempted = true;
 
    if (!this.companyJobTitle.isValid) {
      return;
    }
   

    this.saveCompanyJobTitleClicked.emit(this.companyJobTitle);
    this.editing = false;
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }
}
